import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import * as constants from '../util/constants';
import qs from 'qs';
import helpers from '../util/helpers';
import StoriesSkeleton from '../components/StoriesSkeleton/StoriesSkeleton';

class AppGlobalStories extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      storiesCount: 0,
      allStories: [],
      loadMoreLoading: false,
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.hotel = '';
    this.category = '';

    const hotel = helpers.getParameterByName('hotel');
    if (hotel != null && hotel.length) {
      this.hotel = hotel;
    }

    const category = helpers.getParameterByName('category');
    if (category != null && category.length) {
      this.category = category;
    }

    // Bind "this"
    this.loadStories = this.loadStories.bind(this);
    this.loadMoreStories = this.loadMoreStories.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  componentDidMount() {
    // Load stories on first page load
    this.loadStories();

    $(document).on(constants.EVENT_STORIES_HOTELS_FILTER_CHANGED, (e, hotel) => {
      if (this.hotel !== hotel) {
        this.hotel = hotel;
        this.loadStories();
      }
    });

    $(document).on(constants.EVENT_CATEGORIES_HOTELS_FILTER_CHANGED, (e, category) => {
      if (this.category !== category) {
        this.category = category;
        this.loadStories();
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // Equal height for elements
    if (
      (prevState.loading && !this.state.loading) ||
      (prevState.loadMoreLoading && !this.state.loadMoreLoading)
    ) {
      // Equal height for elements
      $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);
    }
  }

  loadStories() {
    // Stop loading old results
    if (this.state.loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    }

    // Reset state
    this.setState(this.initialState);

    const { postIds } = this.props;

    // Params
    const data = {
      'action': constants.ACTION_GET_GLOBAL_STORIES,
      'postIds' : postIds,
      'hotel': this.hotel,
      'category': this.category,
      'offset': 0,
    };

    // Send request
    axios.post(window.Ode['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const storiesCount = response.data['stories_count'];
          const stories = response.data['stories'];

          if (storiesCount > 0) {
            this.setState({
              loading: false,
              storiesCount: storiesCount,
              allStories: [...stories],
              loadMoreLoading: false,
              loadedAll: parseInt(storiesCount) === stories.length,
            });
          } else {
            this.setState({
              loading: false,
              storiesCount: 0,
              allStories: [],
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        } else {
          this.setState({
            loading: false,
            storiesCount: 0,
            allStories: [],
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  loadMoreStories() {
    const {
      allStories,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({
        loading: false,
        loadMoreLoading: true,
      });

      const { postIds } = this.props;

      // Params
      const data = {
        'action': constants.ACTION_GET_GLOBAL_STORIES,
        'postIds' : postIds,
        'hotel': this.hotel,
        'category': this.category,
        'offset': allStories.length,
      };

      // Send request
      axios.post(window.Ode['ajaxUrl'], qs.stringify(data), {
        cancelToken: this.source.token,
      }).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const storiesCount = response.data['stories_count'];
            const stories = [
              ...allStories,
              ...response.data['stories'],
            ];

            if (storiesCount > 0) {
              this.setState({
                loading: false,
                allStories: [...stories],
                loadMoreLoading: false,
                loadedAll: parseInt(storiesCount) === stories.length,
              });
            } else {
              this.setState({
                loading: false,
                loadMoreLoading: false,
                loadedAll: true,
              });
            }
          } else {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  render() {
    const {
      loading,
      allStories,
      loadMoreLoading,
      loadedAll,
    } = this.state;

    return (
      <React.Fragment>
        {
          !loading && allStories.length > 0 && (
            <React.Fragment>
              {
                (() => {
                  const [firstStory, ...remainingStories] = allStories;
                  return (
                    <React.Fragment>
                      <section className="common-image-text image-text global-stories-image-text">
                        <div className="container">
                          <div className="flex flex-wrap -mx-4">
                            <div className="w-full xl:w-1/2 px-4 left-container">
                              <div className="text-content-wrapper">
                                {firstStory['title'] && (
                                  <div className="upper-content">
                                    <h2 className="article-title">{firstStory['title']}</h2>
                                  </div>
                                )}
                                <div className="lower-content mt-6 xl:mt-0">
                                  {firstStory['description'] && (
                                    <div className="article-description" dangerouslySetInnerHTML={{ __html: firstStory['description'] }}></div>
                                  )}
                                  {firstStory['link'] && (
                                    <a href={firstStory['link']} className="link">Read Story</a>
                                  )}
                                </div>
                              </div>
                            </div>

                            {firstStory['image'] && (
                              <div className="w-full xl:w-1/2 mt-6 xl:mt-0 px-4 right-container">
                                <div className="image-wrapper">
                                  <img src={firstStory['image']} alt="" />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </section>

                      <section className="global-stories-results">
                        <div className="container">
                          <div className="articles-grid">
                            <div className="article-wrapper">
                              {remainingStories.map((item, i) => (
                                <a href={item['link']} className="article-item" key={i}>
                                  {item['image'] && (
                                    <div className="image-container">
                                      <img src={item['image']} alt="" />
                                    </div>
                                  )}
                                  <div className="content-container">
                                    {item['category'] && (
                                      <div className="article-category">{item['category']}</div>
                                    )}
                                    {item['date'] && (
                                      <div className="article-date">{item['date']}</div>
                                    )}
                                    {item['title'] && (
                                      <h3 className="article-title">{item['title']}</h3>
                                    )}
                                    {item['link'] && (
                                      <span className="link link-view">Read Story</span>
                                    )}
                                  </div>
                                </a>
                              ))}
                            </div>
                          </div>
                          <div className="btn-wrapper">
                            <button className="btn btn-outline-black" disabled={loading || loadMoreLoading || loadedAll} onClick={this.loadMoreStories}>
                              {!loadedAll ? 'View More' : 'That\'s All'}
                            </button>
                          </div>
                        </div>
                      </section>
                    </React.Fragment>
                  );
                })()
              }
            </React.Fragment>
          )
        }

        {
          (loading || loadMoreLoading) && (
            <StoriesSkeleton />
          )
        }
      </React.Fragment>
    );
  }
}

AppGlobalStories.propTypes = {
  postIds: PropTypes.string,
};

AppGlobalStories.defaultProps = {
  postIds: '',
};

export default {
  init() {
    // JavaScript to be fired on init
  },
  finalize() {
    // JavaScript to be fired on loaded
    const globalStoriesWrapper = $('#global-stories-wrapper');
    if (globalStoriesWrapper.length) {
      const globalStoriesProps = {...globalStoriesWrapper[0].dataset};

      ReactDOM.render(<AppGlobalStories {...globalStoriesProps} />, globalStoriesWrapper[0]);
    }

    const storiesSortHotels = $('#stories-sort-hotels');
    if (storiesSortHotels.length) {
      storiesSortHotels.on('select2:select', function () {
        const _this = $(this);
        const selectedVal = _this.val();
        const params = helpers.getParameters();

        if (selectedVal !== '') {
          params['hotel'] = selectedVal;
        } else {
          delete params['hotel'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        $(document).trigger(constants.EVENT_STORIES_HOTELS_FILTER_CHANGED, [selectedVal]);
      });
    }

    const storiesSortCategories = $('#stories-sort-categories');
    if (storiesSortCategories.length) {
      storiesSortCategories.on('select2:select', function () {
        const _this = $(this);
        const selectedVal = _this.val();
        const params = helpers.getParameters();

        if (selectedVal !== '') {
          params['category'] = selectedVal;
        } else {
          delete params['category'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        $(document).trigger(constants.EVENT_CATEGORIES_HOTELS_FILTER_CHANGED, [selectedVal]);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalStories.js